import React, { useState } from "react";
import ReactPlayer from "react-player";

import { PlayIcon } from "../../Svg";
import { CreativePhoto, CreativeVideoWrapper, PlayIconWrapper } from "./Creative.styled";

import { isVideo } from "../../utils";

const Creative = ({ url }) => {
  const [hovered, setHovered] = useState(false);
  const isImageURL = !isVideo(url);

  if (isImageURL) {
    return <CreativePhoto src={url} alt="" />;
  }

  return (
    <CreativeVideoWrapper
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <ReactPlayer
        url={url}
        loop
        playing={hovered}
        width="100%"
        height="100%"
        style={{ display: "flex" }}
        controls={false}
      />
      <PlayIconWrapper show={!hovered}>
        <PlayIcon fill="#FFF" />
      </PlayIconWrapper>
    </CreativeVideoWrapper>
  );
};
export default Creative;
